import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { DialogUtils } from "../../helper/dialog.helper";

let FeatureRestrictedComponent = {
    selector: "vcFeatureRestricted",
    templateUrl:
        "/angular/components/feature/feature-restricted-dialog.component.html",
    bindings: {},
    controller: class FeatureRestrictedController {
        private $scope: any;
        private $window: any;
        private dialog: DialogUtils;
        public activeCampaign: Campaign;

        constructor(
            $scope: any,
            $window: any,
            CampaignDataProvider: CampaignDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.$scope = $scope;
            this.$window = $window;
            this.dialog = DialogUtils;

            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
        }

        openUpgradePlanDialog(conversionType: string, ev: object): void {
            this.dialog
                .show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: conversionType,
                    },
                    fullscreen: true,
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                })
                .then(() => this.$window.reload());
        }
    },
};

angular
    // .module("feature", [])
    .module("feature")
    .component(FeatureRestrictedComponent.selector, FeatureRestrictedComponent);
